import { useState } from 'react';

// The one export control, used by every table in the app.
//
// It owns the busy state and the failure message so a table doesn't have to
// grow a banner just to say "that export was too big". ``onExport`` returns a
// promise — a server-streamed download for paged tables, a local build for
// tables the browser already holds whole; the button can't tell and neither
// can the user.
export function ExportCsvButton({
  onExport,
  label = 'Export CSV',
  // Shown while the request is in flight. A filter-wide export can take a
  // while, and a button that looks idle invites a second click.
  busyLabel = 'Exporting…',
  title = 'Download every row matching the current filter as CSV',
  disabled = false,
  // Pass a setter when the page already has a message banner; otherwise the
  // error renders inline next to the button.
  onError,
  style,
}) {
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(null);

  const run = async () => {
    if (busy) return;
    setBusy(true);
    setError(null);
    try {
      await onExport();
    } catch (e) {
      const message = e?.message || 'Export failed';
      if (onError) onError(message); else setError(message);
    } finally {
      setBusy(false);
    }
  };

  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: 8, ...style }}>
      <button
        type="button"
        className="btn btn-sm btn-secondary"
        onClick={run}
        disabled={disabled || busy}
        title={title}
      >
        {busy ? busyLabel : `⬇ ${label}`}
      </button>
      {error && (
        <span style={{ fontSize: 12, color: '#b00020', maxWidth: 420 }}>{error}</span>
      )}
    </div>
  );
}
